// Icon registry (Figma "Icons" section 22:3687). Key = tên icon trong Figma (bỏ tiền tố "Icon/"), value = URL file SVG.
// Thêm icon mới: chỉ cần bỏ file `<ten_icon>.svg` vào folder này, không phải sửa file này.
//
//   import icons from 'assets/icons'
//   <img src={icons.database} />                 // dùng trực tiếp URL
//   <Icon name="database" />                     // hoặc qua components/design-system/Icon (tô màu bằng token)

const files = import.meta.glob('./*.svg', { eager: true, query: '?url', import: 'default' })

const icons = Object.fromEntries(Object.entries(files).map(([path, url]) => [path.slice(2, -4), url]))

export default icons
